import { apiService } from "../api.service";

// Requests
import { BranchRequest } from "../../models/api/requests";

import { Branch } from "../../models/app/domain";
import { isEmpty } from "../../utils";

/**
 * Create branch Request
 * @param branchFormValues - BranchFormModel
 * @return - BranchResponse || ErrorResponse
 */
export const createBranchRequest = async branchFormValues => {
  const payload = new BranchRequest(branchFormValues);
  const response = await apiService.post("/branches", payload);
  if (response.hasError) {
    return response;
  }
  return { branch: new Branch(response.data.branch) };
};

/**
 * Fetch branches Request
 * @return - BranchesResponse || ErrorResponse
 */
export const fetchBranchesRequest = async (lastBranch, searchQuery) => {
  const limit = 10;
  let query = `?with_relations=true&pagination[per_page]=${limit}`;
  if (!isEmpty(lastBranch)) {
    query = query + `&pagination[from]=${lastBranch}`;
  }

  if (searchQuery) {
    query = query + `&search=${searchQuery}`;
  }

  const response = await apiService.get(`/branches${query}`);
  if (response.hasError) {
    return response;
  }
  return {
    branches: response?.data?.items?.map(branch => new Branch(branch)),
    pagination: response?.data?.pagination
  };
};

/**
 * Fetch branch Request
 * @return - BranchResponse || ErrorResponse
 */
export const fetchBranchRequest = async id => {
  const response = await apiService.get(`/branches/${id}`);
  if (response.hasError) {
    return response;
  }
  return { branch: new Branch(response.data.branch) };
};

/**
 * Update branch Request
 * @return - BranchResponse || ErrorResponse
 */
export const updateBranchRequest = async (
  branchFormValues,
  initialValues,
  id
) => {
  const payload = new BranchRequest(branchFormValues);
  payload.removeSameValues(initialValues);
  const response = await apiService.patch(`/branches/${id}`, payload);
  if (response.hasError) {
    return response;
  }
  return { branch: new Branch(response.data.branch) };
};

/**
 * Delte branch Request
 * @param id - string | number
 * @return - MessageResponse || ErrorResponse
 */
export const removeBranchRequest = async id => {
  const response = await apiService.delete(`/branches/${id}`);
  if (response.hasError) {
    return response;
  }
  return { message: "Branch successfully deleted!" };
};
